import { publicApi } from "../../../../helper/api";
import { DocumentUI } from "../entity/document.model";

function getDocumentsByCategory(categoryUuid: string): Promise<DocumentUI[]> {
  return publicApi.get(`/mo/appversion/lists/${categoryUuid}`);
}

function getDocument(uuid: string): Promise<DocumentUI> {
  return publicApi.get(`/mo/appversion/${uuid}`);
}

const documentPublicService = {
  getDocumentsByCategory,
  getDocument,
};

export default documentPublicService;

